var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOptionLabWhiteText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 167.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1419.53,
    y1: 6327.38,
    x2: 1419.53,
    y2: 6224.1,
    gradientTransform: "translate(1516.95 6343.93) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8589d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a49fc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 68.46,
    y1: 103.72,
    x2: 39.45,
    y2: 153.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8589d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82cde5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 41.9,
    y1: 152.77,
    x2: 41.9,
    y2: 70.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f18661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb5b65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 71.89,
    y1: 62.09,
    x2: 100.36,
    y2: 12.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f18661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e72062"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "white_text_dark_background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.38,121.88V37.82L76.48,13.64V97.69l41.9,24.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "76.49 97.69 20.95 129.74 0 117.68 0 167.59 86.5 167.59 62.85 153.95 118.38 121.88 76.49 97.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.95,45.71v84.06l38.24,22.08,3.66,2.11V69.9L20.95,45.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "62.84 69.9 118.38 37.85 139.33 49.91 139.33 0 52.83 0 76.48 13.64 20.95 45.71 62.84 69.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M195.78,56.49c4.66-2.55,10.01-3.87,15.9-3.87s11.24,1.32,15.89,3.87c9.48,5.18,14.93,14.67,14.93,26.26,.26,17.3-13,30.12-30.82,29.86-17.65,.26-31-12.56-30.74-29.86,0-11.59,5.44-21.25,14.84-26.26Zm2.28,40.04c3.51,3.51,8.08,5.27,13.7,5.27s10.19-1.76,13.61-5.27c3.51-3.51,5.27-8.17,5.27-13.88s-1.76-10.27-5.27-13.88c-3.42-3.6-7.99-5.36-13.61-5.36s-10.19,1.84-13.7,5.45c-3.51,3.6-5.27,8.17-5.27,13.79s1.76,10.36,5.27,13.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M289.57,75.81c3.78,4.13,5.62,9.31,5.62,15.54s-1.84,11.33-5.62,15.28c-3.69,3.95-8.43,5.97-14.31,5.97s-10.27-1.76-13.35-5.18v21.43h-10.98v-58.31h10.63l.17,5c3.07-3.95,7.55-5.88,13.52-5.88s10.63,2.02,14.31,6.15Zm-16.51,26.87c6.41,0,11.15-4.83,11.15-11.42s-4.57-11.68-11.15-11.68-11.15,5.01-11.15,11.68,4.74,11.42,11.15,11.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M327.77,79.67h-11.68v16.95c0,4.21,2.28,6.15,6.15,6.15,2.28,0,4.57-.35,6.94-.96l1.05,9.13c-2.81,1.14-6.15,1.67-9.92,1.67-9.4,0-15.19-4.92-15.19-14.4v-18.53h-6.94v-9.13h7.02v-13.17h10.63v13.17h11.94v9.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M341.82,63.69c-3.6,0-6.23-2.55-6.23-6.32s2.63-6.32,6.23-6.32c3.78,0,6.41,2.55,6.41,6.32s-2.63,6.32-6.41,6.32Zm5.62,48.04h-11.06v-41.19h11.06v41.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M377.47,112.61c-6.24,0-11.51-2.02-15.72-6.15-4.13-4.13-6.24-9.22-6.24-15.28s2.11-11.15,6.24-15.28c4.21-4.13,9.48-6.24,15.72-6.24s11.59,2.11,15.72,6.24c4.21,4.13,6.32,9.22,6.32,15.28,0,12.03-9.49,21.43-22.04,21.43Zm0-10.01c6.41,0,11.06-4.83,11.06-11.42s-4.65-11.5-11.06-11.5-11.07,4.83-11.07,11.5,4.74,11.42,11.07,11.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M442.55,74.14c3.07,2.9,4.57,6.85,4.57,11.77v25.82h-10.98v-23.01c0-5.62-3.51-8.78-8.52-8.78s-9.13,3.25-9.13,8.78v23.01h-10.98v-41.19h10.45l.26,4.74c2.37-3.16,6.94-5.62,12.65-5.62,4.83,0,8.69,1.49,11.68,4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M501.73,111.73h-41.28V53.5h7.11v51.81h34.16v6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M542.83,111.73h-6.5v-6.59c-3.07,4.65-8.61,7.46-14.67,7.46-8.52,0-14.31-4.57-14.31-12.03s7.02-12.56,18.18-12.56c3.78,0,7.29,.53,10.54,1.49v-3.25c0-6.67-4.13-10.28-12.12-10.28-4.48,0-9.92,1.32-13.35,3.16l-.7-6.06c3.6-2.11,9.48-3.42,14.4-3.42,12.3,0,18.53,5.8,18.53,16.6v25.47Zm-11.33-7.55c2.63-2.02,4.13-4.48,4.57-7.38v-2.37c-3.42-.97-7.03-1.41-10.71-1.41-7.03,0-11.42,2.72-11.42,7.29,0,4.3,3.34,6.94,8.52,6.94,3.42,0,6.5-1.05,9.05-3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M563.38,111.73h-6.85V51.4h6.85v25.91c3.25-4.57,8.78-7.64,15.81-7.64,5.88,0,10.89,2.02,14.84,6.15,3.95,4.04,5.97,9.13,5.97,15.28,0,12.21-8.96,21.52-20.81,21.52-7.03,0-12.56-2.99-15.81-7.55v6.67Zm25.64-9.75c2.81-2.99,4.22-6.59,4.22-10.89s-1.41-7.9-4.22-10.8c-2.72-2.9-6.23-4.39-10.45-4.39s-8.08,1.49-10.98,4.39c-2.9,2.9-4.3,6.5-4.3,10.8s1.41,7.9,4.3,10.89c2.9,2.9,6.59,4.39,10.98,4.39s7.73-1.49,10.45-4.39Z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionLabWhiteText);
export default __webpack_public_path__ + "static/media/OptionLab_whiteText.57c50db78885a3927361dae972edef66.svg";
export { ForwardRef as ReactComponent };